import { tituloClinico } from "../../../utils/textoClinico";

/* ============================================================================
   CREAR FACTURA · los datos del paciente/cliente, en horizontal

   Sustituye a `CardInfoCliente`, que apilaba cinco filas etiqueta/valor en una
   columna estrecha. Los mismos cinco datos, leídos de los mismos campos, en
   una franja de 12 columnas.

   Los nombres de campo alternativos (`nombre`/`nombres_completos`,
   `cedula`/`identificacion`/`ruc`, ...) se conservan EXACTAMENTE como estaban:
   un paciente y un cliente no traen las mismas claves y ese `||` es la razón.
   ========================================================================== */

/** Los mismos campos que leía CardInfoCliente, en el mismo orden de prioridad. */
export function camposDe(info) {
    if (!info) return null;
    return {
        nombre: info.nombres_completos || info.nombre || "",
        documento: info.cedula || info.identificacion || info.ruc || "",
        correo: info.email || info.correo || info.correo_electronico || "",
        celular: info.celular || info.telefono || "",
        direccion: info.direccion || "",
    };
}

function Dato({ etiqueta, valor, mono, ancho }) {
    // `valor` puede ser un nodo (el chip de cobertura): el `title` sólo se
    // pone cuando es texto, porque un nodo ahi acabaria como "[object Object]".
    const esTexto = typeof valor === "string" || typeof valor === "number";
    return (
        <div className={`fcrear__dato fcrear__dato--${ancho}`}>
            <span className="fcrear__lab">{etiqueta}</span>
            <span
                className={`fcrear__val${mono ? " fcrear__val--mono" : ""}`}
                title={esTexto && valor ? String(valor) : undefined}
            >
                {valor || <span className="fcrear__val-vacio">—</span>}
            </span>
        </div>
    );
}

export default function DatosCliente({ info, cobertura }) {
    const c = camposDe(info);
    if (!c) return null;

    return (
        <div className="fcrear__datos">
            {/* NO se repite el nombre. El selector de al lado YA es la
                identidad del paciente; esta franja son los datos que el
                selector no muestra. El campo "Paciente" ocupaba una columna
                entera para decir lo mismo dos veces. */}
            <Dato etiqueta="Cédula" valor={c.documento} mono ancho="3" />
            <Dato etiqueta="Celular" valor={c.celular} mono ancho="3" />
            <Dato etiqueta="Dirección" valor={c.direccion} ancho="3" />
            {/* La cobertura va como CHIP, igual que en la tabla: es una
                etiqueta de pertenencia, no un dato de texto libre. Y en Title
                Case -- el dato guardado ("LATINASALUD") no se toca. */}
            <Dato
                etiqueta="Cobertura"
                valor={cobertura ? <span className="fcrear__chip-cobertura">{tituloClinico(cobertura)}</span> : ""}
                ancho="3"
            />
        </div>
    );
}
